import { Document, Entry, IReadOnlyRow } from '@belong/types';
import { FSystemIcon } from './elements/elementSystemIcon.factory';
import { FRichText } from './richText.factory';

export type { IReadOnlyRow } from '@belong/types';

export interface IEntryReadyOnlyRow {
  key?: string;
  title?: Document;
  description?: Document;
  icon?: Entry<any>;
  iconAriaLabel?: string;
  available?: boolean;
}

export const isEntryReadyOnlyRow = (entry: Entry<any>): entry is Entry<IEntryReadyOnlyRow> =>
  entry.sys.contentType.sys.id === 'elementReadOnlyRow';

export const FReadOnlyRow = ({ fields, sys }: Entry<IEntryReadyOnlyRow>): IReadOnlyRow => {
  const { available, description, icon, iconAriaLabel, title } = fields;
  return {
    identifier: sys.id,
    available: !!available,
    description: description && FRichText(description),
    icon: fields.icon && FSystemIcon(icon),
    iconAriaLabel,
    title: title && FRichText(title)
  };
};
